import bindFilters from './../../../../../../public/frontend/js/common/listenExport';

export const initLocalization = {
    data() {
        return {
            currentPosition: '',
            gettingLocation: false,
            iptLocalizationLabel: '',
            canChooseCity: true,
            searchNoLocalization: '',
            msgNoLocalization: '',
        }
    },
    methods: {
        allowCities: function() {
            this.canChooseCity = true;
            bindFilters.removeLocalizationOption();
        },
        getCurrentPosition: function() {
           if(!this.canChooseCity)
               return;

           if(!("geolocation" in navigator)) {
               this.errorStr = 'Geolocation is not available.';

               return;
           }
//
//                this.gettingLocation = true;
//
            navigator.geolocation.getCurrentPosition(pos => {
                this.gettingLocation = false;
                this.geolocateWithOpenStreetMap(pos);
//                    this.location = pos;
            }, err => {
                console.log(err.message);
                this.gettingLocation = false;
                if (err.code === err.PERMISSION_DENIED){
                    alert("Il semble que vous ayez bloqué la géolocalisation sur votre navigateur.\n" +
                        "Nous avons besoin de connaitre votre position pour rechercher votre ville.\n" +
                        "Vous pouvez activer cette option à tout moment depuis votre navigateur.");
                }
//                    this.errorStr = err.message;
            });

        },
        parseUrl: function(){
            let _hash = '';

            if(this.hash)
            {
                _hash = this.hash;
            } else {
                _hash = window.location.hash;
            }

            if(_hash != '') {
                var catchHash = _hash.indexOf('&f20');

                if(catchHash > -1) {
                    var new_hash = _hash.substr(_hash.indexOf('&f20') + 5);

                    if(new_hash.indexOf('&') > -1) {
                        var towns = new_hash.substr(0, new_hash.indexOf('&'));
                    } else {
                        var towns = new_hash;
                    }

                    if(towns !== undefined && towns != '') {
                        var _towns = decodeURIComponent(towns).split(',');

                        if(_towns.length) {

                            axios.get('/biens/get-header',{params: {cities: _towns}}).then(response => {
                                if(response.data.cities)
                                {
                                    this.searches = response.data.cities;
                                    this.getIdsFromSearch();
                                }
                            });
                        }
                    }
                } else if(_hash.indexOf('&f130') > -1) {
                    this.$data.canChooseCity = false;
                    this.$data.searchNoLocalization = 130;
                    this.$data.msgNoLocalization = 'Zone personnalisée <i class="fa fa-remove remove-localization"></i>';
                } else if(_hash.indexOf('&f140') > -1) {
                    this.$data.canChooseCity = false;
                    this.$data.searchNoLocalization = 140;
                    this.$data.msgNoLocalization = 'Distance <i class="fa fa-remove remove-localization"></i>';
                } else if(_hash.indexOf('&f150') > -1) {
                    this.$data.canChooseCity = false;
                    this.$data.searchNoLocalization = 150;
                    this.$data.msgNoLocalization = 'Géoloc <i class="fa fa-remove remove-localization"></i>';
                }
            }
        },
        geolocateWithOpenStreetMap: function(position){

            let coordinates = position.coords;
            let stringCoordinates = coordinates.latitude+","+coordinates.longitude;

            axios.get('//nominatim.openstreetmap.org/search', {params: {
                    q: stringCoordinates,
                    format: "json",
                    addressdetails: 1,
                    limit: 1
                }}).then(response => {

                if(response.data &&
                    response.data[0] != undefined &&
                    response.data[0]["address"] != undefined)
                {
                    const address = response.data[0]["address"];

                    let zipcode, city = '';

                    zipcode = address.postcode;
                    city = address.city;

                    if(typeof city == "undefined"){
                        city = address.municipality;
                    }
                    if(city != '' && zipcode != '')
                    {
                        let slug = this.initSlug(city) + '-' + zipcode + '_c3';
                        if(!this.searchesIds.includes(slug)) {
                            axios.get('/biens/get-header',{params: {cities: slug, zip: zipcode}}).then(response => {
                                if(response.data.cities)
                                {
                                    this.currentPosition = response.data.cities;
                                    this.setResult(this.currentPosition, false);
                                }
                            });
                        }
                    }
                }
            });
        },
        initSlug: function (str, separator) {
            str = str.trim();
            str = str.toLowerCase();

            // remove accents, swap ñ for n, etc
            const from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
            const to = "aaaaaaeeeeiiiioooouuuunc------";

            for (let i = 0, l = from.length; i < l; i++) {
                str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
            }

            return str
                .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
                .replace(/\s+/g, "-") // collapse whitespace and replace by -
                .replace(/-+/g, "-") // collapse dashes
                .replace(/^-+/, "") // trim - from start of text
                .replace(/-+$/, "") // trim - from end of text
                .replace(/-/g, separator);
        },
        filteredItems(selected) {
            // filter region
            if(selected.location_type == 1)
            {
                this.searches = this.searches.filter(item => {
                    return (item.location_type === 1 || item.region_code !== selected.region_code);
                });
            }
            // filter department
            else if(selected.location_type == 2)
            {
                this.searches = this.searches.filter(item => {
                    return (item.location_type == 2 || item.department !== selected.reference || item.region_code !== selected.region_code);
                });
            }
            // filter city
            else if(selected.location_type == 3)
            {
                this.searches = this.searches.filter(item => {
                    return (item.location_type == 3 || item.reference !== selected.department || item.region_code !== selected.region_code);
                })
            }

            this.searches.push(selected);
        }
    }
}